import React from 'react';
import styles from './index.module.css';
import { IoCheckmark, IoClose } from 'react-icons/io5';

const PLANS = [
  {
    id: 'basic',
    name: 'BASIC PLAN',
    price: '1500',
    currency: 'LKR',
    period: 'Per month',
    description:
      'Get started with essential POS tools to run your store and manage daily sales with ease.',
    features: [
      { label: 'Basic POS Features', included: true },
      { label: 'Offline Mode (Auto Sync)', included: true },
      { label: 'Basic Inventory Management', included: true },
      { label: 'Basic Reporting Dashboard', included: true },
      { label: 'Multi-Location Management', included: false },
      { label: 'Advanced Product Variants', included: false },
      { label: 'SMS Campaigns', included: false },
      { label: 'Email Marketing Automation', included: false },
      { label: 'Priority Customer Support', included: false },
      { label: 'Custom Reports', included: false },
      { label: 'Third-Party Integrations', included: false },
      { label: 'Regular Updates', included: false },
    ],
    cta: 'Select Basic Plan',
    ctaHref: 'https://onboard.epinics.com/',
    variant: 'basic',
  },
  {
    id: 'premium',
    name: 'PREMIUM PLAN',
    price: '2500',
    currency: 'LKR',
    period: 'Per month',
    description:
      'Unlock the full power of Epinics with advanced features built for growing businesses.',
    badge: 'Best choice',
    features: [
      { label: 'Unlimited access for all pos features', included: true },
      { label: 'Advanced Reporting & Analytics', included: true },
      { label: 'Priority Customer Support', included: true },
      { label: 'Multi-Location Management', included: true },
      { label: 'Advanced Product Variants', included: true },
      { label: 'Delivery Platform Integration', included: true },
      { label: 'SMS Campaigns', included: true },
      { label: 'Email Marketing Automation', included: true },
      { label: 'Priority Customer Support', included: true },
      { label: 'Custom Reports', included: true },
      { label: 'Third-Party Integrations', included: true },
      { label: 'Regular Updates', included: true },

    ],
    cta: 'Select Premium Plan',
    ctaHref: 'https://onboard.epinics.com/',
    variant: 'premium',
  },
];

const PackageSection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>PRICE PLANS</div>
      <div className={styles.subHeading}>BEST CHOICE FOR YOUR BUSINESS</div>
      <div className={styles.cardsGrid}>
        {PLANS.map((plan) => (
          <div
            key={plan.id}
            className={`${styles.planCard} ${
              plan.variant === 'premium' ? styles.planCardPremium : ''
            }`}
          >
            {plan.badge && (
              <span className={styles.badge}>{plan.badge}</span>
            )}
            <p className={styles.planName}>{plan.name}</p>
            <div className={styles.priceRow}>
              <span className={styles.currency}>{plan.currency}</span>
              <span className={styles.price}>{plan.price}</span>
              <span className={styles.period}>{plan.period}</span>
            </div>
            <p className={styles.planDescription}>{plan.description}</p>
            <hr className={styles.divider} />
            <ul className={styles.featureList}>
              {plan.features.map((feature) => (
                <li
                  key={feature.label}
                  className={`${styles.featureItem} ${
                    !feature.included ? styles.featureExcluded : ''
                  }`}
                >
                  <span
                    className={`${styles.featureIcon} ${
                      feature.included
                        ? styles.featureIconIncluded
                        : styles.featureIconExcluded
                    }`}
                    aria-hidden="true"
                  >
                    {feature.included ? (
                      <IoCheckmark />
                    ) : (
                      <IoClose />
                    )}
                  </span>
                  <span className={styles.featureLabel}>{feature.label}</span>
                </li>
              ))}
            </ul>
            <a
              className={`${styles.planCtaLink} ${
                plan.variant === 'premium' ? styles.planCtaLinkPremium : ''
              }`}
              href={plan.ctaHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.planCtaBtn}>{plan.cta}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageSection;
